import React, { Fragment } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import currencyFormat from 'src/utils/formatCOP';
import { useStyles, StyledTableCell } from '../reportsBoard/styles';
import LoadingRows from './LoadingRows';

const TableImportsCompanies = ({
  array = [],
  title = '',
  param,
  order,
  sizeHeader = 3,
}) => {
  // normalizo los segmentos
  const orderParams = array.reduce((newArray, a) => {
    const found = newArray.find((fill) => fill === a[order]);
    if (found === undefined) newArray.push(a[order]);
    return newArray;
  }, []);

  // normalizo los segmentos
  const orderCompanys = array.reduce((newArray, a) => {
    const found = newArray.find((company) => company === a[param]);
    if (found === undefined) newArray.push(a[param]);
    return newArray;
  }, []);

  // agrupo los segmentos Eempresa o parametro.
  function groupBy(arr, prop) {
    const map = new Map(Array.from(arr, (obj) => [obj[prop], []]));
    arr.forEach((obj) => map.get(obj[prop]).push(obj));
    return Array.from(map.values());
  }

  // normalizo el tamaño del segmento
  let tableArray = [];
  tableArray = groupBy(array, param);
  tableArray.forEach((value, index) => {
    orderParams.forEach((parameter) => {
      tableArray[index].push({
        [param]: value[0][param],
        [order]: parameter,
      });
    });
  });

  const classes = useStyles();
  return (
    <>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="small"
          aria-label="spanning table"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">{title}</StyledTableCell>
              {orderCompanys.map((row) => (
                <Fragment key={Math.random()}>
                  <StyledTableCell colSpan={sizeHeader} align="center">
                    {row}
                  </StyledTableCell>
                </Fragment>
              ))}
            </TableRow>
            <TableRow>
              <StyledTableCell align="center">{title}</StyledTableCell>
              {orderCompanys.map(() => (
                <Fragment key={Math.random()}>
                  <StyledTableCell align="center">USD</StyledTableCell>
                  <StyledTableCell align="center">% vs V AA</StyledTableCell>
                  <StyledTableCell align="center">% MIX</StyledTableCell>
                </Fragment>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {orderParams.map((rowTitle, index) => (
              <TableRow key={Math.random()}>
                <TableCell align="left">{rowTitle.toUpperCase()}</TableCell>
                {array.length > 0 ? (
                  tableArray.map((cell) => (
                    <Fragment key={Math.random()}>
                      <TableCell align="right">
                        {currencyFormat(
                          parseInt(cell[index]?.USD || 0, 10),
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {((+cell[index]?.PERIODO1 || 0) * 100).toFixed(2)}
                      </TableCell>
                      <TableCell align="right">
                        {(+cell[index]?.AA || 0).toFixed(2)}
                      </TableCell>
                    </Fragment>
                  ))
                ) : (
                  <TableRow>
                      <TableCell><LoadingRows /></TableCell>
                  </TableRow>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableImportsCompanies;
